import { HiwItems } from "./types";

export const stepItems: HiwItems = [
  {
    question: "Where does Keyzy source homes?",
    answer:
      "<p>At the moment Keyzy is only available to people looking for homes in England & Wales. We are hoping to expand to the rest of the UK in the near future. <br/> Keyzy finds homes for our solution. You can then rent them to buy back later.</p>",
  },
  {
    question: "How long will it take between applying and moving in?",
    answer:
      "<p>Each property will have a date that it is available from, if you have gone through the approval process and the rental is affordable you can move in from that date. </p><br /> <p>This can be a very fast process in many cases so it’s good to be ready to move when the home is available.</p>",
  },
];
